// extracted by mini-css-extract-plugin
export default {"breadcrumb":"ImmersiveHeaderBreadcrumb_breadcrumb__C50ex","link":"ImmersiveHeaderBreadcrumb_link__JQ2nz"};